// extracted by mini-css-extract-plugin
module.exports = {"header":"_2o6cG","addToCalendar":"_2ahBy","desktop":"IGGwj","title":"_27znb","mobile":"_2XyuA"};